(() => {
  const ROOT_SELECTOR = '[data-funny-will-get]';

  class FunnyWillGet {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-fwg-track]');
      this.cards = [...root.querySelectorAll('[data-fwg-card]')];
      this.prev = root.querySelector('[data-fwg-prev]');
      this.next = root.querySelector('[data-fwg-next]');
      this.dotsWrap = root.querySelector('[data-fwg-dots]');
      this.dots = [];

      if (!this.track || !this.cards.length) return;

      this.buildDots();
      this.bind();
      this.updateActive();
    }

    buildDots() {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';

      this.cards.forEach((card, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'fwg-dot';
        dot.setAttribute('aria-label', `Go to item ${index + 1}`);
        dot.addEventListener('click', () => {
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
        this.dotsWrap.appendChild(dot);
        this.dots.push(dot);
      });
    }

    bind() {
      this.prev?.addEventListener('click', () => this.scrollByCard(-1));
      this.next?.addEventListener('click', () => this.scrollByCard(1));

      let raf = null;
      this.track.addEventListener('scroll', () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.updateActive());
      }, { passive: true });

      window.addEventListener('resize', () => this.updateActive(), { passive: true });
    }

    scrollByCard(direction) {
      const current = this.getNearestCardIndex();
      const targetIndex = Math.min(this.cards.length - 1, Math.max(0, current + direction));
      this.cards[targetIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    getNearestCardIndex() {
      const trackBox = this.track.getBoundingClientRect();
      const center = trackBox.left + trackBox.width / 2;
      let bestIndex = 0;
      let bestDistance = Infinity;

      this.cards.forEach((card, index) => {
        const box = card.getBoundingClientRect();
        const cardCenter = box.left + box.width / 2;
        const distance = Math.abs(center - cardCenter);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      return bestIndex;
    }

    updateActive() {
      const active = this.getNearestCardIndex();
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));

      if (this.prev) this.prev.disabled = active === 0;
      if (this.next) this.next.disabled = active === this.cards.length - 1;
    }
  }

  const init = scope => {
    const roots = scope.matches?.(ROOT_SELECTOR)
      ? [scope]
      : [...(scope.querySelectorAll?.(ROOT_SELECTOR) || [])];

    roots.forEach(root => {
      if (root.dataset.fwgReady === 'true') return;
      root.dataset.fwgReady = 'true';
      new FunnyWillGet(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
})();
